import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes";


import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import TablaDeudasEjidos from "./tablaDeudaEjidos";
import TablaHistoricosEjidos from "./tabaHistoricoEjidos";
import { formatMoneda } from "../../../util/varios";
import { Dimmer } from "../../spinner";

export const EstadoCuentaRentas = (props) => {
  /*  variables de estados */

  let op = require("../../../../src/modulos/datos");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [factorCambio, setFactorCambio] = useState(0)

  const [msg2, setMsg2] = useState();
  const [contar1, setContar1] = useState(0);
  const [activate, setActivate] = useState(false);
  const txtCodigoCiu = useRef();
  const txtIdactividad = useRef();
  const txtAlicuota = useRef();
  const txtDescripcionActi = useRef();
  const txtAnios = useRef();
  const txtMinimo = useRef();
  const txtActualizada = useRef();
  const txtCodActividad = useRef();
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [idUsuario, setIdUsuario] = useState();
  const [declaWeb, setDeclaWeb] = useState();
  const txtIdComercio = useRef();
  const txtRitm = useRef();
  const txtNumPatente = useRef();
  const txtDenominacionCome = useRef();
  const txtDireccionContri = useRef();
  const txtEmailContri = useRef();
  const txtCedula = useRef();
  const cmbStatus = useRef();
  const txtObserStatus = useRef();
  const [status, setStatus] = useState();
  const styleTabs = {
    borderTop: "1px solid",
    borderColor: "rgba(0, 88, 129, 1)",
    borderLeft: "none",
    borderTopRightRadius: "16px",
  };

  const handleCloseSi = () => {
    setMostrar1(false);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const imprimirRelacionPago = () => (event) => {
    event.preventDefault();

    var reporte = "Planillacontricomercio";
    var idrentas = props.inmobiliaria.idrentas;
/*     window.open(
      op.reportes + "reporte=" + reporte + "&id=" + idrentas + "&tipo=(16)",
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    ); */

    window.open(op.reportes + "/inmueblesurbanos?" + "reporte=" + reporte + "&id=" + idrentas +  "&tipo=(16)", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
   

  };

  const salir = () => {
    props.onHideCancela();
  };
  const handlerClickTab = (index, lastIndex, event) => {
    //alert("Tab seleccionado: " + index + " .\ Tab anterior seleccionado: " + lastIndex);
    if (operacion === 1 && (index === 2 || index === 3)) {
      setTabIndex(0);
    } else {
      setTabIndex(index);
    }
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setTabIndex(0);
        setFactorCambio(props.factorCambio)
        if (props.inmobiliaria && props.inmobiliaria.status === 0) {
          setStatus("ACTIVO");
        } else if (props.inmobiliaria && props.inmobiliaria.status === 1) {
          setStatus("INACTIVO");
        } else {
          setStatus("error");
        }
      }}
    >
      <Modal.Header className="azulGradiant">
        <Modal.Title style={{ color: "#fff" }}>
          {operacion === 1
            ? "Agregar Estado Cuenta."
            : operacion === 2
              ? "Editar Estado Cuenta."
              : operacion === 3
                ? "Eliminar Estado Cuenta."
                : "Detalles de Deuda de Propiedad Inmoboiliaria."}
        </Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={salir}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ color: "rgb(106, 115, 123)" }}>
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <MensajeSiNo
          titulo={titulo2}
          mensaje={msg2}
          show={mostrar1}
          onHideSi={handleCloseSi}
          onHideNo={handleCloseNo}
        />
        <Dimmer active={activate} >
        </Dimmer>
        <div
          className="col-md-12 row"
         
        >
          <div
            className="row col-md-12 rounded border border-secundary"
            style={{ margin: 0, padding: "10px" }}
          >
            <div
              className="container"
              style={{ backgroundColor: "", color: "" }}
            >
              <h3
                className="col-md-8"
                style={{
                  fontFamily: "Times New Roman, Times, serif",
                  fontWeight: "bold",
                }}
              >
                Detalle Deuda Contribuyente Ejido
              </h3>
              <div className="input-group mr-0 input-group-sm mb-1 col-md-2">
                <span className="input-group-text bg-transparent fw-bold border-0">Valor Euro €:</span>
                <span className="input-group-text bg-transparent fw-bold border-0">{formatMoneda(factorCambio.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</span>

              </div>
              <table
                className="table table-sm v-100"
                style={{
                  fontFamily: "Times New Roman, Times, serif",
                  fontSize: "15px",
                }}
              >
                <tbody>
                  <tr>
                    <td>
                      <span className="">Código Contribuyente: &nbsp; </span>
                      <label for="colFormLabelSm" className="form-label">
                        {" "}
                        {props.inmobiliaria
                          ? props.inmobiliaria.idrentas !== null
                            ? props.inmobiliaria.idrentas.trim()
                            : ""
                          : ""}
                      </label>
                    </td>
                    <td>
                      <span className=""> Tipo de Renta: &nbsp; </span>
                      <label for="colFormLabelSm" className="form-label">
                        {props.rentas ? props.rentas.descripcion : ""}{" "}
                      </label>
                    </td>
                    <td>
                      <span className=""> Estatus: &nbsp; </span>
                      <label for="colFormLabelSm" className="form-label">
                        {status}
                      </label>
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-primary rounded-pill"
                        onClick={imprimirRelacionPago("Planillacontricomercio")}
                      >
                        {" "}
                        <i className="fas fa-print">Relación Pagos Web</i>{" "}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              className="container"
              style={{ backgroundColor: "", color: "" }}
            >
              <table
                className="table table-sm v-100"
                style={{
                  fontFamily: "Times New Roman, Times, serif",
                  fontSize: "15px",
                }}
              >
                <tbody>
                  <tr>
                    <td>
                      <span className="">
                        {" "}
                        Nombre del Contribuyente: &nbsp;{" "}
                      </span>
                      <label for="colFormLabelSm" className="form-label">
                        {" "}
                        {props.inmobiliaria
                          ? props.inmobiliaria.nombrearrendatario !== null
                            ? props.inmobiliaria.nombrearrendatario.trim()
                            : ""
                          : ""}
                      </label>
                    </td>
                    <td>
                      <span className=""> Cedula: &nbsp; </span>
                      <label for="colFormLabelSm" className="form-label">
                        {" "}
                        {props.inmobiliaria
                          ? props.inmobiliaria.cedrif !== null
                            ? props.inmobiliaria.cedrif.trim()
                            : ""
                          : ""}
                      </label>
                    </td>
                    <td>
                      <span className=""> Dirección del inmueble: &nbsp; </span>
                      <label for="colFormLabelSm" className="form-label">
                        {" "}
                        {props.inmobiliaria
                          ? props.inmobiliaria.direccion !== null
                            ? props.inmobiliaria.direccion.trim()
                            : ""
                          : ""}
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <ul className="nav" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link active bg-blue-100 text-light"
                id="datosTributarios"
                data-bs-toggle="tab"
                data-bs-target="#tributarios"
                type="button"
                role="tab"
                aria-controls="tributarios"
                aria-selected="true"

              >
                Deudas Inmobiliarias
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-200 text-light"
                disabled={operacion === 1 || operacion === 3 ? true : false}
                id="deuda-tab"
                data-bs-toggle="tab"
                data-bs-target="#deuda"
                type="button"
                role="tab"
                aria-controls="deuda"
                aria-selected="false"

              >
                Historicos de Pagos de Rentas Inmobiliarias
              </a>
            </li>
          </ul>

          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="tributarios"
              role="tabpanel"
              aria-labelledby="datosTributarios"
            >
              <TablaDeudasEjidos
              factorCambio={props.factorCambio}
                tabdeuda={props.deuda}
                idrentas={props.inmobiliaria && props.inmobiliaria.idrentas}
                petro={props.valorUT}
                visibleF={"visible"}
                credito={
                  props.credito && props.credito > 0 ? props.credito : 0.0
                }
              />
            </div>

            <div
              className="tab-pane fade"
              id="deuda"
              role="tabpanel"
              aria-labelledby="deuda-tab"
            >
              <TablaHistoricosEjidos
                tabHis={props.historico}
                idrentas={props.inmobiliaria && props.inmobiliaria.idrentas}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnCancela}
          onClick={salir}
          className="btn btn-sm btn-danger rounded-pill col-md-1"
        >
          <i className="fas fa-window-close"> Salir</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};
